/** @file The viewport ghost of a plan under review, or null (no preview, or the user switched it off). */
import type { ViewportGhost } from '../../stores/ghostStore';
import { actionOf } from './actionOf';
import { AUTORIG_LIMITS } from './autorigLimits.data';
import type { ReviewView } from './autorigTypes';

/** Owner `autorig`; overlays per analysis (AUTORIG_ACTIONS). */
export function ghostOf(view: ReviewView): ViewportGhost | null {
  if (!view.ghost || view.preview.kind !== 'ghost') return null;
  return { owner: 'autorig', doc: view.preview.doc, opacity: AUTORIG_LIMITS.ghostOpacity, overlays: actionOf(view.request.fn).overlays };
}
